<template>
  <form action="Products" @submit.prevent="submitForm">
    <div class="input-group mb-2">
      <input
          :ariaLabel="placeholderText"
          v-model="searchTerm"
          @input="onInput"
          name="term"
          type="text"
          class="form-control"
          :placeholder="placeholderText"
          autocomplete="off"
      />
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" type="submit">
          <i class="fal fa-search"></i>
          <span class="sr-only">{{ placeholderText }}</span>
        </button>
      </div>
    </div>

    <div
        v-if="suggestions.length"
        class="border rounded p-3 bg-white shadow-sm position-relative"
    >
      <div class="font-weight-bold mb-3">{{ totalText }}: {{ totalResults }}</div>
      <ul class="list-unstyled mb-2">
        <li
            v-for="product in suggestions"
            :key="product.id"
            class="mb-2"
        >
          <a
              :href="product.url"
              class="d-flex align-items-center rounded text-body"
              style="text-decoration: none;"
          >
            <img
                :src="product.image"
                alt="img"
                class="mr-3"
                width="64"
                height="64"
            />
            <div>
              <div class="font-weight-semibold" style="line-height: 1.1">
                {{ product.name }}
              </div>
              <div class="text-muted small">{{ product.code }}</div>
            </div>
          </a>
        </li>
      </ul>
      <button
          type="button"
          class="btn btn-block btn-outline-primary"
          @click="submitForm"
      >
        {{ moreText }} ({{ totalResults }})
      </button>
    </div>
  </form>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  apiUrl: { type: String, required: true },
  totalText: {
    type: String,
    default: 'Znaleziono {{ totalResults }} produktów',
  },
  moreText: {
    type: String,
    default: 'Zobacz wszystkie',
  },
  placeholderText: {
    type: String,
    default: 'Szukaj produktów',
  }
})

const searchTerm = ref('')
const suggestions = ref([])
const totalResults = ref(0)

let debounceTimeout = null

const onInput = () => {
  clearTimeout(debounceTimeout)
  if (!searchTerm.value.trim()) {
    suggestions.value = []
    totalResults.value = 0
    return
  }
  debounceTimeout = setTimeout(() => {
    fetchSuggestions(searchTerm.value)
  }, 300)
}

const fetchSuggestions = async (term) => {
  try {
    const url = `${props.apiUrl}?term=${encodeURIComponent(term)}&return=json`
    const response = await fetch(url)
    const data = await response.json()
    totalResults.value = parseInt(data.count)
    suggestions.value = data.products.slice(0, 10)
  } catch (e) {
    console.error('Błąd pobierania danych:', e)
    suggestions.value = []
    totalResults.value = 0
  }
}

const submitForm = () => {
  const form = document.createElement('form')
  form.method = 'GET'
  form.action = 'Products'
  const input = document.createElement('input')
  input.type = 'hidden'
  input.name = 'term'
  input.value = searchTerm.value
  form.appendChild(input)
  document.body.appendChild(form)
  form.submit()
}

const formattedTotalText = computed(() =>
    props.totalText.replace('{{ totalResults }}', totalResults.value)
)
</script>

<style scoped>
.font-weight-semibold {
  font-weight: 600;
}
</style>
